import { useEffect, useState } from "react";
import { resolveFestivalMapUrl } from "@/lib/festivalMap";

/**
 * Resolve a briefing's festival map to a URL suitable for <img src>.
 *
 * Returns null while loading or when the briefing has no map. The
 * signed URL is regenerated whenever map_storage_path changes; the
 * Supabase signed URL TTL is 1 hour, plenty for a normal session view
 * but short enough to not leak out of band indefinitely.
 */
export function useFestivalMapUrl(
  briefing:
    | {
        map_storage_path?: string | null;
      }
    | null
    | undefined,
): string | null {
  const [url, setUrl] = useState<string | null>(null);
  const storagePath = briefing?.map_storage_path ?? null;

  useEffect(() => {
    let cancelled = false;
    if (!storagePath) {
      setUrl(null);
      return;
    }
    resolveFestivalMapUrl({ map_storage_path: storagePath })
      .then((resolved) => {
        if (!cancelled) setUrl(resolved);
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [storagePath]);

  return url;
}
